import { isCcpaBannerVariantActive } from '../consent-manager/flags';
import { isUrlPricingPage } from '../welcome';

export interface CookieWallVariation {
  artistName: string;
  backgroundImage: string;
  sharedTitle: string;
  tTitle: string;
  tSubtitle: string;
  tText: string;
  titleClass: string;
  subtitleClass: string;
  textClass: string;
  variant: string;
  trackingCategory: string;
  coverClass?: string;
}

export enum CookieWallVariant {
  TreesLong = 'trees-long',
  PaidMedia = 'paid-media',
}

export const getCookieWallVariation = (): CookieWallVariation => {
  if (isCcpaBannerVariantActive() && isUrlPricingPage()) {
    return {
      artistName: '',
      backgroundImage: 'welcome__background__variant',
      sharedTitle: 'cookie_wall_paid.snippet',
      tTitle: 'cookie_wall_paid.heading',
      tSubtitle: '',
      tText: 'cookie_wall_paid.description',
      titleClass: 'welcome__title_cookie_wall_paid',
      subtitleClass: '',
      textClass: 'welcome__cookie-notice-intro-cookie_wall_paid',
      variant: CookieWallVariant.PaidMedia,
      coverClass: 'welcome__cover--transparent',
      trackingCategory: `${CookieWallVariant.PaidMedia}`,
    };
  }

  return {
    artistName: 'Sea Trees',
    backgroundImage: 'welcome__background__trees_bg_image',
    sharedTitle: 'transfer.consent-manager.art.title-small',
    tTitle: 'transfer.consent-manager.trees.title',
    tSubtitle: 'transfer.consent-manager.trees.subtitle',
    tText: 'transfer.consent-manager.trees.text',
    titleClass: 'welcome__title_big_trees_long',
    subtitleClass: 'welcome__cookie-notice-intro-trees-long',
    textClass: 'welcome__cookie-notice-text-trees-long',
    variant: CookieWallVariant.TreesLong,
    trackingCategory: `cmp_bcorp_${CookieWallVariant.TreesLong}`,
  };
};
